var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeSwitcherClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand_more_black_24dp (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.93262 5.83704L10.3676 9.27954L6.93262 12.722L7.99012 13.7795L12.4901 9.27954L7.99012 4.77954L6.93262 5.83704Z",
    fill: "#4D5758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeSwitcherClosed);
export default __webpack_public_path__ + "static/media/tree-switcher-closed.0ef73a3f0394de83733659566ec8c162.svg";
export { ForwardRef as ReactComponent };